import Fuse from 'fuse.js';
import PROPERTIES from '../properties';

const staticAbbr = PROPERTIES.injection.Route.map((route) => route.n);

const fuseConfig = {
    threshold: 0.1,
};

const generativeFuseConfig = {
    threshold: 0.4,
};

const staticFuse = new Fuse(staticAbbr, fuseConfig);

export const onRouteSearch = async (text: string, genie_routes: string[]): Promise<string[]> => {
    if (!text.trim()) {
        return new Promise((resolve, _) => {
            const loweredText = text.toLowerCase();
            const options = genie_routes
                .filter((t) => t.toLowerCase().includes(loweredText))
                .map((t) => t);
            if (text && !options.find((t) => t.toLowerCase() === loweredText)) {
                options.push(text);
            }
            resolve(options);
        });
    }

    const allOptions: string[] = [];

    const isStaticAbbr = staticFuse.search(text);
    if (isStaticAbbr && isStaticAbbr.length) {
        allOptions.push(...isStaticAbbr.map((t) => t.item));
    }

    return new Promise((resolve, _) => {
        const allOptionsFuse = new Fuse(allOptions, generativeFuseConfig);
        const searchedOptions = allOptionsFuse.search(text).map((t) => t.item);
        if (!searchedOptions.find((item) => item.toLowerCase().startsWith(text.toLowerCase()))) {
            searchedOptions.push(text);
        }
        resolve(searchedOptions);
    });
};
